.container {
  text-align: center;
  position: relative;
}

.title {
  font-weight: bold;
}

.subtitle {
  font-size: 12px;
}

.content {
  display: grid;
  gap: 0.75rem;
  text-align: left;
  position: relative;
}

@media (min-width: 768px) {
  .content {
    grid-column: span 2 / span 2;
  }
}

.formGrid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  padding: 16px 0;
  height: 500px;
  overflow-y: auto;
}

@media (min-width: 768px) {
  .formGrid {
    grid-template-columns: 1fr 1fr;
    gap: 24px;
  }
}

.textLeft {
  text-align: left;
}

.errorText {
  font-size: 12px;
  color: red;
}

.actions {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 1rem;
}

.button {
  padding: 0.5rem;
  border-radius: 0.5rem;
  transition: all;
  transition-duration: 300ms;
  cursor: pointer;
  border: none;
}
.button:active {
  transform: scale(95%);
}

.buttonGray {
  width: 40%;
  background-color: #ddd8d8;
  color: #241e1e;
  border: none;
}

.buttonRed {
  width: 40%;
  background-color: #d20000;
  color: white;
  border: none;
}

.feedbackStatus {
  padding-inline: 20px;
}
